<section id="portfolio">
    <div class="content">
        <div class="headline">
            <div class="shortblueline"></div>
            <h2>Portfolio</h2>
            <div class="longblueline"></div>
        </div>
        <span>{{text.description}}</span>
        <app-project></app-project>
    </div>
</section>